export const SITE_TYPE = "SHOPBY_PRO";

export const SHOPBY_PRO_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/pages/login/login.html" },
  SIGNUP_INTRO: {
    target: `${SITE_TYPE}:SIGNUP_INTRO`,
    url: "/pages/join/method.html",
  },
  SIGNUP_AGREEMENT: {
    target: `${SITE_TYPE}:SIGNUP_AGREEMENT`,
    url: "/pages/join/agreement.html",
  },
  SIGNUP_MAIN: {
    target: `${SITE_TYPE}:SIGNUP_MAIN`,
    url: "/pages/join/join.html",
  },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/pages/my/mypage.html" },
  FIND_ID: {
    target: `${SITE_TYPE}:FIND_ID`,
    url: "/pages/find-id/find-id.html",
  },
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/pages/find-password/find-password.html",
  },
  CART: { target: `${SITE_TYPE}:CART`, url: "/pages/order/cart.html" },
  POLICY: {
    target: `${SITE_TYPE}:POLICY`,
    url: "/pages/service/use-terms.html",
  },
  PRIVACY: {
    target: `${SITE_TYPE}:PRIVACY`,
    url: "/pages/service/privacy-policy.html",
  },
  PRODUCT_LIST: {
    target: `${SITE_TYPE}:PRODUCT_LIST`,
    url: "/pages/product/list.html",
  },
  PRODUCT_DETAIL: {
    target: `${SITE_TYPE}:PRODUCT_DETAIL`,
    url: "//pages/product/view.html",
  },
};
